import { BrandList } from "@database/common-schema";
import { getCaPublishConfigDefaults } from "@modules/assembler-data-schema";
import { defineStore } from "pinia";
const de = {
  brandName: "{brand}",
  feedApi: {
    createAlreadyExists: "Feed kann nicht erstellt werden, da bereits ein Feed mit diesem Namen existiert",
    updateAlreadyExists: "Feed kann nicht aktualisiert werden, da bereits ein Feed mit diesem Namen existiert",
    created: "Feed erstellt",
    updated: "Feed aktualisiert",
    notFound: "Feed nicht gefunden",
    requiredFields: "Sie können den Feed nicht speichern, da obligatorische Informationen fehlen"
  },
  feedList: {
    newButton: "Neuer Feed",
    name: "Nach Feed-Name suchen",
    deleteAssemblerFeed: "Löschen",
    dpAny: "Alle",
    active: "Status",
    loading: "Laden von Feed",
    partner: "Partner",
    feedName: "Feed-Name",
    feedURL: "Feed-URL",
    lastModified: "Zuletzt geändert",
    dpEdit: "Bearbeiten",
    dpView: "Siehe",
    messageDeleted: "Nachricht gelöscht",
    errorOnDeleting: "Fehler beim Löschen",
    createFeed: "Feed erstellen",
    secondaryFilters: {
      all: "Alle",
      true: "Wahr",
      false: "Falsch",
      autopublish: "Autopublishing",
      importType: "Feed Typ",
      periodicPull: "Aktiver Import",
      isContentVisibleInCtf: "Inhalt in CTF sichtbar"
    }
  },
  feed: {
    feedLabel: "Feed",
    backButton: "Zurück zur Feed-Liste",
    newFeed: "Neues Feed",
    messagedeleteAssemblerFeed: "Feed löschen",
    messagedeleteAssemblerFeedTitle: "Sind Sie sicher, dass Sie dieses Feed löschen möchten?",
    deleteAssemblerFeed: "Löschen",
    duplicateFeed: "Duplizieren",
    messageDeleted: "Feed gelöscht",
    errorOnDeleting: "Es gab einen Fehler beim Löschen des Feeds",
    errorFailedLoadedFeedWithId: "Es gab einen Fehler beim Abrufen des Feeds"
  },
  feedEdit: {
    label: "Bezeichnung",
    counter: "Zähler",
    backButton: "Zurück zur Feed-Liste",
    editFeed: "Feed bearbeiten",
    messageSaved: "Feed gespeichert",
    fetchMethodTooltip: "GET ist die Standardmethode zum Abrufen von Inhalten. POST sollte nur in besonderen Situationen verwendet werden. Wenn Sie sich nicht sicher sind, welche Methode verwendet werden soll, verwenden Sie die GET-Methode"
  },
  feedEditTabs: {
    generalTab: "Allgemein",
    contentTab: "Inhalt",
    settingsTab: "Zusätzliche Einstellungen",
    previewTab: "Vorschau",
    xmlTab: "XML",
    historyTab: "Geschichte"
  },
  feedEditGeneralTab: {
    feedName: "Feed-Name",
    feedUrl: "Feed-URL",
    feedType: "Feed-Typ",
    activeImport: "Aktiver Import",
    cpImport: "CP-Einfuhr",
    publisher: "Partner",
    publisherId: "VIBE Partner ID",
    feedId: "VIBE Feed ID",
    note: "Hinweis",
    isContentVisibleInCtf: "Inhalt in CTF sichtbar",
    feedFetchMethod: "Feed-Abrufmethode"
  },
  feedEditContentTab: {
    filters: {
      regexPatterns: { label: "Regex-Muster", inputLabel: "Muster eingeben" },
      whiteListedLinks: { label: "Erlaubte Links", inputLabel: "Link eingeben" },
      htmlPatterns: { label: "HTML-Muster", inputLabel: "Muster eingeben" }
    }
  },
  feedEditSettingsTab: {
    eTag: "eTag",
    insertedContent: {
      sectionLabel: "Inhaltsblöcke",
      newContentBlock: "Neuer Inhaltsblock",
      tooltipText: "Hier können Textblöcke zu jedem Artikel des Feeds hinzugefügt werden. Diese werden am Ende des Artikels angezeigt. Es sind mehrere Textblöcke möglich und diese lassen sich sortieren."
    },
    mapConfig: {
      sectionLabel: "Mapping-Konfiguration",
      item: { label: "Artikel", path: "Pfad" },
      leadText: {
        label: "Vorspann",
        type: "Typ",
        path: "Pfad"
      },
      inlineImages: { label: "Inline-Bilder", wrapperEl: "Inline-Bildpfad", creditsEl: "Kreditpfad", captionEl: "Beschriftungspfad" }
    },
    modes: {
      sectionLabel: "Authentifizierung",
      authenticationMode: {
        authentication: "Authentifizierung",
        basicAuthUsername: "Benutzername",
        basicAuthPassword: "Passwort",
        authUrl: "Authentifizierung URL",
        authTokenField: "Token",
        authenticationType: {
          noAuthentication: "Keine Authentifizierung",
          basicAuthentication: "Basis-Authentifizierung",
          tokenAuthentication: "Token-Authentifizierung"
        },
        contentCreationType: {
          createOnly: "Nur erstellen",
          createUpdate: "Erstellen und aktualisieren"
        }
      },
      contentCreationMode: "Inhaltserstellungsmodus"
    },
    additionalSettings: {
      sectionLabel: "Zusätzliche Einstellungen",
      inactivityNotificationEmail: { label: "Inaktivitätsbenachrichtigungs-E-Mail", inputLabel: "E-Mail eingeben" },
      importNotificationEmail: { label: "Importbenachrichtigungs-E-Mail", inputLabel: "E-Mail eingeben" }
    },
    publishConfig: {
      sectionLabel: "Veröffentlichungskonfiguration",
      addNew: "Neu hinzufügen",
      autopublish: "Automatische Veröffentlichung",
      channelPrimary: "Primärer Kanal",
      channelsSecondary: "Sekundäre Kanäle",
      jobGroup: "Jobgruppe",
      hideFromNewsTicker: "Nicht im newsticker anzeigen",
      hideFromMostRecent: "Nicht im teaser listing anzeigen",
      adsEnabled: "Werbung aktiviert",
      outstreamEnabled: "Outstream aktiviert",
      isNoIndex: "NoIndex aktivieren",
      unpublishAfterDaysInput: "Offline nehmen nach ... Tagen",
      unpublishAfterDaysToggle: "Offline nehmen nicht gekaufter Inhalte",
      unpublishBoughtAfterDaysToggle: "Offline nehmen gekaufter Inhalte",
      defaultAuthorsInput: "Standardautoren"
    },
    fetchConfig: {
      sectionLabel: "Konfiguration abrufen",
      priority: "Feed-Priorität",
      contentFetchSchedules: "Zeitpläne für Inhaltsabruf",
      addCustomFetchSchedule: "Benutzerdefinierten Abrufzeitplan hinzufügen",
      addPredefinedFetchSchedule: "Vordefinierten Abrufzeitplan hinzufügen",
      activeFetchSchedules: "Aktive Abrufpläne",
      invalidCronExpression: "Der Cron-Ausdruck ist ungültig.",
      fetchSchedules: {
        ["10sec"]: "10 Sekunden",
        ["30sec"]: "30 Sekunden",
        ["1min"]: "1 Minute",
        ["5min"]: "5 Minuten",
        ["10min"]: "10 Minuten",
        ["30min"]: "30 Minuten",
        ["1h"]: "1 Stunde",
        ["4h"]: "4 Stunden",
        ["12h"]: "12 Stunden",
        custom: "Benutzerdefiniert"
      }
    },
    position: "Position",
    positionTooltip: "Legen Sie die Position des eingefügten Blocks innerhalb des Artikels fest. Verwenden Sie positive Zahlen (0, 1, 2), um den Block als 1., 2. ... vom Anfang aus zu positionieren. Verwenden Sie negative Zahlen (-1, -2, ...), um den Block als 2., 3., ... vom Ende des Artikels aus zu positionieren. Verwenden Sie sehr große Zahlen (9999), um den Block als letzten Block des gesamten Artikels zu positionieren.",
    blockType: "Blocktyp",
    placeholderImageConfigs: {
      tooltipText: "Symbolbilder werden verwendet, wenn kein Bild mitgeliefert wird. Es kann pro Marke separat konfiguriert werden, und es muss per Haken aktiv gesetzt werden.",
      sectionLabel: "Symbolbildkonfigurationen",
      isEnabled: "Ist Aktiviert",
      imageNotFoundWarning: "Symbolbild für @.capitalize:brandName wurde nicht gefunden. Bitte ersetzen oder deaktivieren.",
      imageNotPublishedWarning: "Symbolbild für @.capitalize:brandName wurde nicht veröffentlicht. Bitte ersetzen oder deaktivieren.",
      imageNotLicensedWarning: "Symbolbild für @.capitalize:brandName ist nicht lizenziert. Bitte ersetzen oder deaktivieren.",
      goToImageEditPageLabel: "Zur Bildbearbeitungsseite gehen"
    }
  },
  feedPreviewTab: {
    errorMessage: "Die Vorschau für den angeforderten Feed konnte nicht empfangen werden.",
    noArticlesErrorMessage: "Keine Artikel zur Vorschau erhalten. Bitte überprüfen Sie die Feed-URL und Ihre Einstellungen."
  },
  feedXmlTab: {
    invalidImportType: "Der Importtyp des Feeds ist nicht XML.",
    feedSourceFetchError: "Fehler beim Abrufen der Feed-Quelle.",
    feedSourceParseError: "Fehler beim Parsen der Feed-Quelle.",
    wrapAutoToggleLabel: "Automatischer Umbruch",
    wrapCharSelectLabel: "Zeilenlänge umbrechen",
    copyHtmlLabel: "HTML kopieren",
    copyToClipboardSuccess: "HTML erfolgreich in die Zwischenablage kopiert",
    copyToClipboardError: "HTML konnte nicht in die Zwischenablage kopiert werden"
  },
  feedHistoryTab: {
    errorContents: "Inhalt mit Importfehler",
    fetchHistory: "Verlauf abrufen"
  },
  publishType: {
    all: "Alle",
    none: "Keine",
    auto: "Auto-Publish",
    manual: "Manuelles Publizieren"
  }
};
const en = {
  brandName: "{brand}",
  feedApi: {
    createAlreadyExists: "Can't create Feed because another Feed with this name already exists",
    updateAlreadyExists: "Can't update Feed because another Feed with this name already exists",
    created: "Feed created",
    updated: "Feed updated",
    notFound: "Feed not found",
    requiredFields: "You can't save the Feed because mandatory information is missing"
  },
  feedList: {
    newButton: "New Feed",
    name: "Search by feed name",
    deleteAssemblerFeed: "Delete",
    dpAny: "All",
    active: "Active",
    loading: "Loading Feed",
    partner: "Partner",
    feedName: "Feed Name",
    feedURL: "Feed URL",
    lastModified: "Last Modified",
    dpEdit: "Edit",
    dpView: "View",
    messageDeleted: "Message deleted",
    errorOnDeleting: "Error on deleting",
    createFeed: "Create Feed",
    secondaryFilters: {
      all: "All",
      true: "True",
      false: "False",
      autopublish: "Autopublish",
      importType: "Feed Type",
      periodicPull: "Active Import",
      isContentVisibleInCtf: "Content visible in CTF"
    }
  },
  feed: {
    feedLabel: "Feed",
    backButton: "Back to Feed list",
    newFeed: "New Feed",
    messagedeleteAssemblerFeed: "Delete Feed",
    messagedeleteAssemblerFeedTitle: "Are you sure you want to delete this Feed?",
    deleteAssemblerFeed: "Delete",
    duplicateFeed: "Duplicate",
    messageDeleted: "Feed Deleted",
    errorOnDeleting: "There was an error deleting the Feed ",
    errorFailedLoadedFeedWithId: "There was an error getting the Feed"
  },
  feedEdit: {
    label: "Label",
    counter: "Counter",
    backButton: "Back to Feed list",
    editFeed: "Edit Feed",
    messageSaved: "Feed saved",
    fetchMethodTooltip: "GET is default method used for fetching content. POST should be used only in special situations. If you are not sure which method should be used, use GET method"
  },
  feedEditTabs: {
    generalTab: "General",
    contentTab: "Content",
    settingsTab: "Additional Settings",
    previewTab: "Preview",
    xmlTab: "XML",
    historyTab: "History"
  },
  feedEditGeneralTab: {
    feedName: "Feed Name",
    feedUrl: "Feed URL",
    feedType: "Feed Type",
    activeImport: "Active Import",
    cpImport: "CP Import",
    publisher: "Partner",
    publisherId: "VIBE Partner ID",
    feedId: "VIBE Feed ID",
    note: "Note",
    isContentVisibleInCtf: "Content visible in CTF",
    feedFetchMethod: "Feed Fetch Method"
  },
  feedEditContentTab: {
    filters: {
      regexPatterns: { label: "Regex Patterns", inputLabel: "Enter pattern" },
      whiteListedLinks: { label: "Whitelisted Links", inputLabel: "Enter link" },
      htmlPatterns: { label: "HTML Patterns", inputLabel: "Enter pattern" }
    }
  },
  feedEditSettingsTab: {
    eTag: "eTag",
    insertedContent: {
      sectionLabel: "Inserted Content Blocks",
      newContentBlock: "New Content Block",
      tooltipText: "Text blocks can be added to each article in the feed here. They are displayed at the end of the article. Multiple text blocks are possible and you can sort them."
    },
    mapConfig: {
      sectionLabel: "Mapping Configuration",
      item: { label: "Item", path: "Path" },
      leadText: {
        label: "Lead Text",
        type: "Type",
        path: "Path"
      },
      inlineImages: { label: "Inline Images", wrapperEl: "Inline Image Path", creditsEl: "Credits Path", captionEl: "Caption Path" }
    },
    modes: {
      sectionLabel: "Authentication",
      authenticationMode: {
        authentication: "Authentication",
        basicAuthUsername: "Username",
        basicAuthPassword: "Password",
        authUrl: "Authentication URL",
        authTokenField: "Token",
        authenticationType: {
          noAuthentication: "No authentication",
          basicAuthentication: "Basic authentication",
          tokenAuthentication: "Token authentication"
        },
        contentCreationType: {
          createOnly: "Create only",
          createUpdate: "Create and Update"
        }
      },
      contentCreationMode: "Content creation Mode"
    },
    additionalSettings: {
      sectionLabel: "Additional Settings",
      inactivityNotificationEmail: { label: "Inactivity Notification Email", inputLabel: "Enter email" },
      importNotificationEmail: { label: "Import Notification Email", inputLabel: "Enter email" }
    },
    publishConfig: {
      sectionLabel: "Publish Configuration",
      addNew: "Add New",
      autopublish: "Automatic Publishing",
      channelPrimary: "Primary Channel",
      channelsSecondary: "Secondary Channels",
      jobGroup: "Team",
      hideFromNewsTicker: "Hide from newsticker",
      hideFromMostRecent: "Hide from most recent",
      adsEnabled: "Ads enabled",
      outstreamEnabled: "Outstream enabled",
      isNoIndex: "Activate NoIndex",
      unpublishAfterDaysInput: "Unpublish after days",
      unpublishAfterDaysToggle: "Unpublish not-bought articles",
      unpublishBoughtAfterDaysToggle: "Unpublish bought articles",
      defaultAuthorsInput: "Default authors"
    },
    fetchConfig: {
      sectionLabel: "Fetching Configuration",
      priority: "Feed Priority",
      contentFetchSchedules: "Content Fetch Schedules",
      addCustomFetchSchedule: "Add Custom Fetch Schedule",
      addPredefinedFetchSchedule: "Add Predefined Fetch Schedule",
      activeFetchSchedules: "Active Fetch Schedules",
      invalidCronExpression: "The Cron expression is not valid.",
      fetchSchedules: {
        ["10sec"]: "10 seconds",
        ["30sec"]: "30 seconds",
        ["1min"]: "1 minute",
        ["5min"]: "5 minutes",
        ["10min"]: "10 minutes",
        ["30min"]: "30 minutes",
        ["1h"]: "1 hour",
        ["4h"]: "4 hours",
        ["12h"]: "12 hours",
        custom: "Custom"
      }
    },
    position: "Position",
    positionTooltip: "Set position of the inserted block within the article. Use positive number (0, 1, 2) to position the block as 1st, 2nd ... from the beginning. Use negative number (-1, -2, ...) to position the block as 2nd, 3rd, ... from the end of the article. Use really big number (9999) to position the block as the last block of the whole article.",
    blockType: "Block type",
    placeholderImageConfigs: {
      tooltipText: "Placeholder image would be used if main image is not found during import. It can be configured per brand and placeholder image must be set as enabled.",
      sectionLabel: "Placeholder Image Configs",
      isEnabled: "Is Enabled",
      imageNotFoundWarning: "Placeholder image for @.capitalize:brandName was not found. Please replace or disable it.",
      imageNotPublishedWarning: "Placeholder image for @.capitalize:brandName is not published. Please replace or disable it.",
      imageNotLicensedWarning: "Placeholder image for @.capitalize:brandName is not licensed. Please replace or disable it.",
      goToImageEditPageLabel: "Go to image edit page"
    }
  },
  feedPreviewTab: {
    errorMessage: "Failed to receive preview for requested feed.",
    noArticlesErrorMessage: "No articles received for preview. Please verify the feed URL and check your settings."
  },
  feedXmlTab: {
    invalidImportType: "The import type of the Feed is not XML.",
    feedSourceFetchError: "Failed to retrieve the Feed source.",
    feedSourceParseError: "Failed to parse the Feed source.",
    wrapAutoToggleLabel: "Auto-wrap",
    wrapCharSelectLabel: "Wrap line length",
    copyHtmlLabel: "Copy HTML",
    copyToClipboardSuccess: "HTML copied to clipboard succesfully",
    copyToClipboardError: "Failed copying HTML to clipboard"
  },
  publishType: {
    all: "All",
    none: "None",
    auto: "Auto-publish",
    manual: "Manual publish"
  },
  feedHistoryTab: {
    errorContents: "Contents with import error",
    fetchHistory: "Fetch history"
  }
};
const messages = { en, de };
const routes = [
  {
    path: "/assembler-feeds",
    children: [
      {
        path: "",
        name: "assembler_feed_list",
        component: () => import("./feed-list.view-CnifGzZq.js"),
        meta: { requiredRight: "manage_partners" }
      },
      {
        path: "new",
        name: "assembler_feed_new",
        component: () => import("./feed-edit.view-B8KWcSTw.js"),
        props: () => ({
          backRoute: "/assembler-feeds"
        }),
        meta: { requiredRight: ["manage_partners"] }
      },
      {
        path: ":id",
        name: "assembler_feed_detail",
        component: () => import("./feed-edit.view-B8KWcSTw.js"),
        props: (route) => ({
          id: route.params.id,
          backRoute: "/assembler-feeds",
          tab: route.query.tab
        }),
        meta: { requiredRight: ["manage_partners"] }
      }
    ]
  }
];
var FeedFetchMethodEnum = /* @__PURE__ */ ((FeedFetchMethodEnum2) => {
  FeedFetchMethodEnum2["GET"] = "GET";
  FeedFetchMethodEnum2["POST"] = "POST";
  return FeedFetchMethodEnum2;
})(FeedFetchMethodEnum || {});
const FEED_FETCH_METHODS = [
  {
    label: "GET",
    value: "GET"
    /* GET */
  },
  {
    label: "POST",
    value: "POST"
    /* POST */
  }
];
const FEED_TYPE_OPTIONS = ["XML", "JSON"];
var MapConfigLeadTextTypeEnum = /* @__PURE__ */ ((MapConfigLeadTextTypeEnum2) => {
  MapConfigLeadTextTypeEnum2["XPATH"] = "Xpath";
  MapConfigLeadTextTypeEnum2["FIRST_PARAGRAPH"] = "First Paragraph";
  return MapConfigLeadTextTypeEnum2;
})(MapConfigLeadTextTypeEnum || {});
var AuthenticationEnum = /* @__PURE__ */ ((AuthenticationEnum2) => {
  AuthenticationEnum2["NONE"] = "No authentication";
  AuthenticationEnum2["BASIC_AUTHENTICATION"] = "Basic authentication";
  AuthenticationEnum2["TOKEN_AUTHENTICATION"] = "Token authentication";
  return AuthenticationEnum2;
})(AuthenticationEnum || {});
const allBrands = [...BrandList];
const useEditorAssemblerFeed = defineStore(
  "feed",
  {
    state: () => ({
      loading: false,
      partner: void 0,
      feed: {
        feedUrl: "",
        feedFetchMethod: FeedFetchMethodEnum.GET,
        feedName: "",
        partnerUuid: "",
        importType: "XML",
        additionalSettings: {
          importNotificationEmail: [],
          inactivityNotificationEmail: []
        },
        authTokenField: "",
        authUrl: "",
        basicAuthPassword: "",
        basicAuthUsername: "",
        filters: {
          htmlPatterns: [],
          regexPatterns: [],
          whiteListedLinks: []
        },
        contentFetchSchedules: ["* */10 * * * *"],
        publishConfigs: allBrands.map((brand) => ({
          brand,
          ...getCaPublishConfigDefaults()
        })),
        placeholderImageConfigs: [],
        isContentVisibleInCtf: true,
        mappingConfiguration: {
          item: {
            path: "//rss/channel/item"
          },
          leadText: {
            type: "XPATH",
            path: "description/"
          },
          inlineImages: {
            wrapperEl: ""
          }
        },
        modes: {
          contentCreationMode: "CREATE_ONLY",
          authenticationMode: "NONE"
        },
        periodicPull: false,
        priority: 5,
        lastFetchedDate: void 0,
        nextFetchDate: void 0
      },
      prefillSource: void 0,
      meta: {
        updateShownDate: false
      }
    }),
    actions: {
      addInsertBlock(block) {
        const newBlock = structuredClone(block);
        if (Array.isArray(this.feed.insertContentBlocks))
          this.feed.insertContentBlocks.push(newBlock);
        else
          this.feed.insertContentBlocks = [newBlock];
        this.remapInsertBlocksOrder();
      },
      removeInsertBlock(index) {
        if (Array.isArray(this.feed.insertContentBlocks) && this.feed.insertContentBlocks[index]) {
          this.feed.insertContentBlocks.splice(index, 1);
          this.remapInsertBlocksOrder();
        }
      },
      updateInsertBlocksArray(blocksArray) {
        this.feed.insertContentBlocks = blocksArray;
        this.remapInsertBlocksOrder();
      },
      moveInsertBlock(direction, index) {
        const { insertContentBlocks } = this.feed;
        if (!Array.isArray(insertContentBlocks))
          return;
        if (direction === "up" && index === 0)
          return;
        if (direction === "down" && index === (insertContentBlocks == null ? void 0 : insertContentBlocks.length) - 1)
          return;
        const firstNewItem = insertContentBlocks[direction === "up" ? index : index + 1];
        const secondNewItem = insertContentBlocks[direction === "up" ? index - 1 : index];
        if (!firstNewItem || !secondNewItem)
          return;
        const spliceIndex = direction === "up" ? index - 1 : index;
        insertContentBlocks.splice(spliceIndex, 2, firstNewItem, secondNewItem);
        this.remapInsertBlocksOrder();
      },
      remapInsertBlocksOrder() {
        var _a;
        (_a = this.feed.insertContentBlocks) == null ? void 0 : _a.forEach((block, i) => {
          block.insertOrder = i;
        });
      },
      addEmptyPublishConfig(brand) {
        if (!this.feed.publishConfigs)
          this.feed.publishConfigs = [];
        this.feed.publishConfigs.push({
          brand,
          ...getCaPublishConfigDefaults()
        });
      },
      removePublishConfig(brand) {
        var _a;
        this.feed.publishConfigs = (_a = this.feed.publishConfigs) == null ? void 0 : _a.filter((config) => config.brand !== brand);
      },
      addEmptyPlaceholderImageConfig(brand) {
        if (!this.feed.placeholderImageConfigs)
          this.feed.placeholderImageConfigs = [];
        this.feed.placeholderImageConfigs.push({
          brand,
          imageUuid: void 0,
          isEnabled: false
        });
      },
      removePlaceholderImageConfig(brand) {
        var _a;
        this.feed.placeholderImageConfigs = (_a = this.feed.placeholderImageConfigs) == null ? void 0 : _a.filter((config) => config.brand !== brand);
      }
    }
  }
);
const prefillEditorAssemblerFeed = (source, data) => {
  const storeInstance = useEditorAssemblerFeed();
  storeInstance.prefillSource = source;
  storeInstance.feed = { ...storeInstance.feed, ...data };
};
const assemblerFeedModule = {
  messages,
  routes
};
export {
  AuthenticationEnum as A,
  FeedFetchMethodEnum as F,
  MapConfigLeadTextTypeEnum as M,
  FEED_TYPE_OPTIONS as a,
  FEED_FETCH_METHODS as b,
  assemblerFeedModule as c,
  prefillEditorAssemblerFeed as p,
  useEditorAssemblerFeed as u
};
//# sourceMappingURL=index-Z9UtozR0.js.map
